import "./grid-layout.css.ts.vanilla.js";
var r = "_379jdb2", d = "_379jdb1", v = "_379jdb0", o = "_379jdb4", e = "_379jdb6", p = {
    colSpan: "var(--_379jdb5)",
    verticalSpace: "var(--_379jdb3)"
};
export { r as desktopLargeColumn, d as desktopMediumColumn, v as desktopSmallColumn, o as grid, e as span, p as vars };
